module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr21-db6f97ef169c0f3bdfcb9e17fb7f5f62.jpg";